/**
 * This method toggles css class on body tag on dragging.
 * @param {String} cssClass Cursor grab css class
 * @param {Boolean} isDragging Dragging status
 */
export const handleDraggingCursor = (cssClass, isDragging) => {
    if (isDragging) {
        document.getElementsByTagName('body')[0].classList.add(cssClass);
    } else {
        document.getElementsByTagName('body')[0].classList.remove(cssClass);
    }
};

/**
 * This method will toggle selected css class to months.
 * @param {Number} i Current month index
 * @param {Number} startIndex Filtered section start month index
 * @param {Number} endIndex Filtered section end month index
 * @returns Css class
 */
export const calculateMonthSelection = (i, startIndex, endIndex, cssClass) => {
    if (startIndex <= i && i <= endIndex) {
        return cssClass;
    } else {
        return '';
    }
};

/**
 * Concat Month and Year text to show in filter.
 * @param {Array} list Month list
 * @param {Number} index Month index
 * @returns {String} Month year concatenation
 */
export const getMonthYearText = (list, index) =>
    `${list[index].monthText} ${list[index].year}`;
